export enum Events {
    showMainMenu = 'showMainMenu',
    continueStory = 'continueStory',
    resetProgressData = 'resetProgressData',
    showResetPopup = 'showResetPopup',
    showSettings = 'showSettings',
    updatedResourceAmount = 'updatedResourceAmount',
    updatedResourceTicker = 'updatedResourceTicker',
    attemptBuyBooster = 'attemptBuyBooster',
    playLevel = 'playLevel',
    levelLost = 'levelLost',
    userInput = 'userInput',
    gamePaused = 'gamePaused',
    levelFinish = 'levelFinish',
    rewardStatusUpdated = 'rewardStatusUpdated',
    updateDailyRewardTicker = 'updateDailyRewardTicker',
    showCheatPopup = 'showCheatPopup',
    startOver = 'startOver',
    gameResumed = 'gameResumed',
    settingMusicSet = 'settingMusicSet',
    settingSFXSet = 'settingSFXSet',
    playLoadingAnimation = 'playLoadingAnimation',
    stopLoadingAnimation = 'stopLoadingAnimation',
    interstitialShown = 'interstitialShown',

    SDK_GAME_START = 'SDK_GAME_START',
    SDK_GAME_PAUSE = 'SDK_GAME_PAUSE',
    CONTENT_PAUSE_REQUESTED = 'CONTENT_PAUSE_REQUESTED',
    CONTENT_RESUME_REQUESTED = 'CONTENT_RESUME_REQUESTED',
    AD_SDK_CANCELED = 'AD_SDK_CANCELED',
    SDK_REWARDED_WATCH_COMPLETE = 'SDK_REWARDED_WATCH_COMPLETE',
    AD_ERROR = 'AD_ERROR',
    SKIPPED = 'SKIPPED',
    SDK_READY = 'SDK_READY',
    AD_SDK_MANAGER_READY = 'AD_SDK_MANAGER_READY'
}